/**
 * Converts a date string (ISO, YYYY-MM-DD, or similar) to DD/MM/YYYY format.
 * @param {string} raw - Date string
 * @returns {string} Formatted date as DD/MM/YYYY, or original string if invalid
 */
export function formatToDDMMYYYY(raw) {
  if (!raw) return ""
  const date = new Date(raw)
  if (isNaN(date.getTime())) return raw
  const dd = String(date.getUTCDate()).padStart(2, "0")
  const mm = String(date.getUTCMonth() + 1).padStart(2, "0")
  const yyyy = date.getUTCFullYear()
  return `${dd}/${mm}/${yyyy}`
}
